import { IntegrationType } from '../../../server/mpsklad_core/Entity/IntegrationType'

const STORAGE_KEY = 'mpcard-nav-context'

export type MpCardNavContext = {
  integrationType: IntegrationType
  accountId: number
}

export const saveMpCardNavContext = (context: MpCardNavContext): void => {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context))
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

const isIntegrationTypeValue = (value: unknown): value is IntegrationType =>
  value === IntegrationType.Ozon ||
  value === IntegrationType.Wildberries ||
  value === IntegrationType.MoySklad ||
  value === IntegrationType.YandexMarket

const isMpCardNavContext = (value: unknown): value is MpCardNavContext => {
  if (!isRecord(value)) {
    return false
  }

  const accountId = value['accountId']
  const integrationType = value['integrationType']

  return typeof accountId === 'number' &&
    accountId > 0 &&
    isIntegrationTypeValue(integrationType)
}

export const loadMpCardNavContext = (): MpCardNavContext | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY)

  if (!raw) {
    return null
  }

  try {
    const parsed: unknown = JSON.parse(raw)

    if (!isMpCardNavContext(parsed)) {
      return null
    }

    return parsed
  } catch {
    return null
  }
}
